<template>
  <Modal 
    ref="contractModalRef"
    @onNegativeActionClick="closeModal"
    @onPositiveActionClick="acceptContract"
    class="contractModal"
    :modalStyle="{ width: '800px' }"
  >
    <template v-slot:body>
      <div class="contract-modal-content">
        <div class="contract-text" v-html="contractText"></div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ref } from 'vue';
import { Modal } from '@n11/so-ui-components';
import useEarlySettlementContract from '../../services/contractService';

export default {
  name: "ContractModal",
  components: {
    Modal,
  },
  setup(props, { emit }) {
    const contractModalRef = ref(null);
    const { data: contractText, fetchContract } = useEarlySettlementContract();
    
    const openModal = async () => {
      if (!contractModalRef.value) return;
      
      await fetchContract();
      
      if (contractText.value) {
        contractModalRef.value.openModal();
      }
    };
    
    const closeModal = () => {
      if (contractModalRef.value) {
        contractModalRef.value.closeModal();
      }
    };
    
    const acceptContract = () => {
      emit('accept');
      closeModal();
    };
    
    return {
      contractModalRef,
      contractText,
      openModal,
      closeModal,
      acceptContract,
    };
  },
  emits: ['accept'],
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.contractModal {
  :deep(.icon-wrapper) {
    display: none !important;
  }
}

.contract-modal-content {
  .contract-text {
    h3 {
      font-size: 18px;
      font-weight: 600;
      color: $colorN80;
      margin: 24px 0 12px 0;
      
      &:first-child {
        margin-top: 0;
      }
    }
    
    p {
      font-size: 14px;
      color: $colorN70;
      line-height: 20px;
      margin-bottom: 12px;
    }
    
    ul {
      margin: 12px 0;
      padding-left: 20px;
      
      li {
        font-size: 14px;
        color: $colorN70;
        line-height: 20px;
        margin-bottom: 8px;
        
        strong {
          color: $colorN80;
        }
      }
    }
  }
}
</style>
